/* SSL landing, concept D — Agentcy for SickScience */
(() => {
  const formatMoney = (cents, format = '${{amount}}') => {
    const value = Number(cents) / 100;
    const key = (format.match(/\{\{\s*(\w+)\s*\}\}/) || [])[1] || 'amount';
    const group = (num, dec, th = ',', dp = '.') => {
      const [i, f] = num.toFixed(dec).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (f ? dp + f : '');
    };
    let out = key.includes('comma') ? group(value, key.includes('no_decimals') ? 0 : 2, '.', ',')
      : group(value, key.includes('no_decimals') ? 0 : 2);
    out = out.replace(/[.,]00$/, '');
    return format.replace(/\{\{\s*\w+\s*\}\}/, out);
  };

  class SslRoutine extends HTMLElement {
    connectedCallback() {
      this.fmt = this.dataset.moneyFormat || '${{amount}}';
      this.threshold = Number(this.dataset.threshold) || 0;
      this.inputs = [...this.querySelectorAll('[data-routine-item]')];
      this.list = this.querySelector('[data-routine-list]');
      this.empty = this.querySelector('[data-routine-empty]');
      this.total = this.querySelector('[data-routine-total]');
      this.ship = this.querySelector('[data-routine-ship]');
      this.bar = this.querySelector('[data-routine-bar]');
      this.button = this.querySelector('[data-routine-add]');
      this.label = this.querySelector('[data-routine-label]');
      this.error = this.querySelector('[data-routine-error]');
      this.baseLabel = this.label ? this.label.textContent : '';
      this.addEventListener('change', (e) => { if (e.target.matches('[data-routine-item]')) this.render(); });
      this.button?.addEventListener('click', () => this.add());
      this.render();
    }

    get selected() { return this.inputs.filter((i) => i.checked && !i.disabled); }

    render() {
      const items = this.selected;
      const sum = items.reduce((t, i) => t + Number(i.dataset.price), 0);
      this.list.innerHTML = '';
      items.forEach((i) => {
        const li = document.createElement('li');
        const name = document.createElement('span');
        name.textContent = i.dataset.title;
        const price = document.createElement('span');
        price.textContent = formatMoney(i.dataset.price, this.fmt);
        li.append(name, price);
        this.list.append(li);
      });
      this.empty.hidden = items.length > 0;
      this.total.textContent = formatMoney(sum, this.fmt);
      this.button.disabled = items.length === 0;
      if (this.label) this.label.textContent = items.length ? `${this.baseLabel} (${items.length})` : this.baseLabel;
      if (this.ship && this.threshold > 0) {
        const left = this.threshold - sum;
        const done = left <= 0;
        this.ship.classList.toggle('is-done', done);
        this.ship.textContent = done
          ? 'Free shipping unlocked'
          : `Add ${formatMoney(left, this.fmt)} more for free shipping`;
        this.bar.style.width = `${Math.min(100, (sum / this.threshold) * 100)}%`;
      }
    }

    async add() {
      const items = this.selected.map((i) => ({ id: Number(i.value), quantity: 1 }));
      if (!items.length) return;
      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');
      this.error.hidden = true;
      try {
        const res = await fetch(`${(window.Shopify && Shopify.routes && Shopify.routes.root) || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (!res.ok) throw new Error(`cart/add ${res.status}`);
        if (this.dataset.afterAdd === 'stay') {
          const cart = await fetch(`${(window.Shopify && Shopify.routes && Shopify.routes.root) || '/'}cart.js`).then((r) => r.json());
          ['cart:refresh', 'cart:change', 'cart:updated'].forEach((name) => {
            document.documentElement.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { cart, baseEvent: 'variant:add' } }));
          });
          this.button.disabled = false;
        } else {
          window.location.href = `${(window.Shopify && Shopify.routes && Shopify.routes.root) || '/'}cart`;
        }
      } catch (err) {
        this.error.hidden = false;
        this.button.disabled = false;
      } finally {
        this.button.removeAttribute('aria-busy');
      }
    }
  }

  class SslStickyBuy extends HTMLElement {
    connectedCallback() {
      const target = document.querySelector(this.dataset.target || '#buy');
      if (!target || !('IntersectionObserver' in window)) return;
      const io = new IntersectionObserver(([entry]) => {
        const past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.hidden = !past;
      });
      io.observe(target);
      this.querySelector('a')?.addEventListener('click', (e) => {
        e.preventDefault();
        target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      });
    }
  }


  class SslMarquee extends HTMLElement {
    connectedCallback() {
      const root = this.closest('.ssl-proofbar');
      const btn = this.querySelector('button');
      if (!root || !btn) return;
      btn.addEventListener('click', () => {
        const paused = root.classList.toggle('is-paused');
        btn.setAttribute('aria-pressed', String(paused));
        btn.setAttribute('aria-label', paused ? btn.dataset.labelPlay : btn.dataset.labelPause);
      });
    }
  }
  if (!customElements.get('ssl-marquee')) customElements.define('ssl-marquee', SslMarquee);
  if (!customElements.get('ssl-routine')) customElements.define('ssl-routine', SslRoutine);
  if (!customElements.get('ssl-sticky-buy')) customElements.define('ssl-sticky-buy', SslStickyBuy);
})();
